import React, { Component } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import { printCwtPdf, viewCwtPdf } from '../../Utilities/WSUtil';
import { Document, Page, pdfjs } from 'react-pdf';
import Loader from '../../components/ui/Loader';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//     'pdfjs-dist/build/pdf.worker.min.mjs',
//     import.meta.url,
// ).toString();



class ViewPdf extends Component {
    constructor(props) {
        super(props);
        this.onAgree = this.onAgree.bind(this);
        this.loadSuccess = this.loadSuccess.bind(this);
        this.print = this.print.bind(this);

        this.state = {
            pdfData: null,
            pages: 1,
            cwtFilename: null,
            period: null,
            mid: null,
            confirm: false,
            schedule: null,
            loading: false,
            pdfLoaded: false,
            isPdfReprinted: false,
            errorMessage: '',
            hasError: false
        }
    }

    componentDidMount() {
        // const getQueryStringParams = query => {
        //     return query
        //         ? (/^[?#]/.test(query) ? query.slice(1) : query)
        //             .split('&')
        //             .reduce((params, param) => {
        //                 let [key, value] = param.split('=');
        //                 params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
        //                 return params;
        //             }, {}
        //             )
        //         : {}
        // };

        // var params = getQueryStringParams(this.props.location.search);

        // var params = { merchant: '0123456700', schedule: 'M', period: '2025-1' }

        if (this.props.pdfFile) {
            var params = { merchant: this.props.pdfFile.merchant, schedule: this.props.pdfFile.taxSched, period: this.props.pdfFile.period, filename: this.props.pdfFile.filename, reprint: this.props.pdfFile.reprint }
            // var params = { merchant: '0001004852', schedule: 'M', period: '2023-09', filename: 'CWT2307_0001004852_092023.pdf' }


            this.setState({ loading: true });
            viewCwtPdf(params)
                .then(response => {
                    this.setState({ pdfData: response.data, mid: params.merchant, cwtFilename: params.filename, period: params.period, schedule: params.schedule, loading: false, pdfLoaded: true, isPdfReprinted: params.reprint });
                    this.props.getPdfFile(response.data);
                })
                .catch(error => {
                    this.setState({ loading: false, pdfLoaded: false, errorMessage: error.message })
                });

        }

    }
    onAgree(event) {
        var agree = event.target.checked
        this.setState({ agree: agree });
    }
    loadSuccess(pages) {
        this.setState({ pages: pages.numPages, pdfLoaded: true });
    }
    modalHide() {
        this.setState({ confirm: false, agree: false });
    }
    onDownload() {
        this.modalHide();
        this.setState({ loading: true })
        printCwtPdf({ cwt: this.state.cwtFilename, mid: this.state.mid, period: this.state.period, schedule: this.state.schedule })
            .then(() => {
                this.setState({ loading: false });
                window.print();
                this.props.history.goBack();
            }).catch(error => {
                this.setState({ loading: false, hasError: true, errorMessage: error.message });
            });
    }

    hideErrorModal() {
        this.setState({ hasError: false, errorMessage: '' });
    }

    print() {
        this.setState({ confirm: true });
    }

    goBack = e => {
        e.preventDefault();

        this.props.history.goBack();
    }

    renderPdf(data) {
        if (data) {
            return (
                <Document file={data} className="pdf-document"
                    onLoadSuccess={this.loadSuccess}>

                    {
                        Array.from(new Array(this.state.pages), (el, index) => <Page pageNumber={index + 1} renderTextLayer={false} renderAnnotationLayer={false} scale={1.12} className="pdf-page" />)
                    }

                </Document>
            )
        }
        return (<div style={{ color: 'red' }}>{this.state.errorMessage}</div>)
        // return (<div style={{ color: 'red' }}>Error in retrieving PDF. Please contact administrator</div>)
    }

    renderContent() {
        if (!this.state.loading) {
            return (
                <>
                    <div className="printable-area print-view">
                        {this.renderPdf(this.state.pdfData)}
                    </div>
                    <div className="action-btn-group">
                        <button className="submit-btn" onClick={this.print} disabled={!this.state.pdfLoaded}>Print</button>
                        <button className="submit-btn" onClick={this.goBack}>Back</button>
                    </div>
                </>
            );
        }
    }
    render() {
        return (
            <div>
                {this.renderContent()}
                <Modal dialogClassName="modal-bdo modal-custom" show={this.state.confirm} backdrop={'static'} centered={true} backdropClassName='fade' onHide={() => this.modalHide()}>
                    <Modal.Header closeButton>

                    </Modal.Header>
                    <Modal.Body >
                        <div style={{ textAlign: 'center' }}>IMPORTANT NOTE ON USE OF TAX CREDIT CERTIFICATE</div>
                        <div style={{ paddingBottom: '10px', textAlign: 'center' }}>
                            BDO shall not be liable for any consequences resulting from the unauthorized or multiple downloading or printing of the CWT and use thereof for unlawful purpose. It shall be the responsibility of the merchant to ensure that only authorized users can access MORS and all information and document obtained from MORS shall be kept confidential and used for lawful purpose.
                        </div>
                        <div style={{ paddingBottom: '10px', textAlign: 'center' }}>
                            By ticking this box, I signify that I have read, understood and agreed to the terms concerning use of the Creditable Withholding Tax certificates as stipulated in
                        </div>
                        <div style={{ paddingBottom: '20px', textDecoration: 'underline', textAlign: 'center' }}>
                            SECTION 257. Penal Liability for Making False Entries, Records or Reports, or Using Falsified or Fake Accountable Forms. ---xxx (B) Any person who: xxx (8) Willfully attempts in any manner to evade or defeat any tax imposed under this Code, or knowingly uses fake or falsified xxx Tax Credit Certificates xxx and other accountable forms shall, upon conviction for each act or omission, be punished by a fine of not less than Fifty thousand pesos (P50,000) but not more than One hundred thousand pesos (P100,000) and suffer imprisonment of not less than two (2) years but not more than six (6) years."
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <input type="checkbox" style={{ marginRight: '10px' }} onChange={event => this.onAgree(event)} />I Understand
                        </div>
                        <Row align="center" style={{ paddingTop: '10px' }}>
                            <Col>
                                <button className="submit-btn" onClick={() => { this.onDownload() }} disabled={!this.state.agree}>OK</button>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.loading} backdrop={'static'} centered={true} backdropClassName='fade' dialogClassName="modal-bdox">
                    <div>
                        {/* <OverlayLoader
                            color={'#0B2972'}
                            loader="ClipLoader"
                            text="Loading..."
                            active={true}
                            backGroundColor={'black'}
                            opacity=".9">
                        </OverlayLoader> */}

                        <Loader text="Loading ..."></Loader>
                    </div>
                </Modal>
                <Modal dialogClassName="modal-bdo" show={this.state.hasError} backdrop={'static'} centered={true} backdropClassName='fade' onHide={() => this.hideErrorModal()}>
                    <Modal.Header style={{ backgroundColor: '#0B2972', height: '40px', padding: '15px, 0px' }}>
                        <Modal.Title style={{ fontSize: '14px', color: 'white' }}><span>Printing failed</span></Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <div style={{ color: 'red' }}>
                            {this.state.errorMessage}
                        </div>
                        <Row align="center" style={{ paddingTop: '10px' }}>
                            <Col>
                                <button className="submit-btn" onClick={() => this.hideErrorModal()}>OK</button>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </div >
        );
    }



}

export default ViewPdf;
